<template>
  <div>
    <img v-if="pc" :src="$t('viewpoints.img')" width="100%" />
    <img v-else :src="$t('viewpoints.imgm')" width="100%" />
    <div class="mw1200" :class="{mlr: !pc}" style="margin: 60px auto">
      <div class="h1_p">
        <h1 :class="{f36: !pc}">{{$t('viewpoints.h1')}}</h1>
        <p :class="{f20: !pc}" :style="{lineHeight: pc?'1.2':'26px'}" v-html="pc ? $t('viewpoints.p') : $t('viewpoints.p').replace(/&lt;br>/, '')"></p>
      </div>
      <div v-if="pc" style="display: flex;justify-content: space-between;margin-bottom: 50px">
        <div style="width: 60%">
          <div v-for="i in 3" style="line-height: 17px;margin-bottom: 80px" :key="i">
            <template v-if="(page - 1) * 3 + i -1 < $t('viewpoints.list').length">
              <img :src="isEn?`/acnImg/viewpoints/author/${$t('viewpoints.list')[(page - 1) * 3 + i -1].author}.png`:`/acnImg/viewpoints/author/c/${$t('viewpoints.list')[(page - 1) * 3 + i -1].author}.png`"
                   style="margin-bottom: 30px"
                   width="80%" />
              <div v-html="$t('viewpoints.list')[(page - 1) * 3 + i -1].p"></div>
              <div v-if="i === 1 ? m1 : (i === 2 ? m2 : m3)" v-html="$t('viewpoints.list')[(page - 1) * 3 + i -1].more"></div>
              <div style="margin-top: 30px;border-bottom: 1px solid #cccccc;width: 100%">
              <span @click="more(i)" style="cursor: pointer">
                <template v-if="i === 1 ? m1 : (i === 2 ? m2 : m3)">
                  {{isEn ? '' : ''}} <a-icon type="" />
                </template>
                <template v-else>
                  {{isEn ? '' : ''}} <a-icon type="" />
                </template>
              </span>  <span style="cursor: pointer" @click="pdf2($t('viewpoints.list')[(page - 1) * 3 + i -1].name)">{{isEn?' ':' '}}</span>
              </div>
            </template>
          </div>
          <a-pagination style="margin-top: -40px" v-model="page" :total="$t('viewpoints.list').length" :pageSize="3" size="small" @change="change" />
        </div>
        <div style="width: 30%">
          <a-pagination style="border-bottom: 1px #B3B3B3 solid;margin-bottom: 20px;padding-bottom: 20px" v-model="current" :total="$t('home.viewpoints.videos').length" :pageSize="6" size="small" />
          <template v-for="i in 6">
            <template v-if="(current -1) * 6 + i - 1 < $t('home.viewpoints.videos').length">
              <div :key="i" style="margin-bottom: 50px;border-bottom: 1px #B3B3B3 solid;padding-bottom: 5px">
                <video width="100%" controls="controls" style="object-fit:fill"
                       :src="$t('home.viewpoints.videos')[(current -1) * 6 + i - 1].src"
                       :poster="$t('home.viewpoints.videos')[(current -1) * 6 + i - 1].poster"
                ></video>
                <div v-html="$t('home.viewpoints.videos')[(current -1) * 6 + i - 1].name" style="font-size: 18px;color: #7f1f20;margin: 15px 0 3px 0;line-height: 20px"></div>
                <span style="font-size: 16px;font-weight: 600">{{$t('home.viewpoints.videos')[(current -1) * 6 + i - 1].author}}</span>
                <span style="font-size: 16px"> - {{$t('home.viewpoints.videos')[(current -1) * 6 + i - 1].title}}</span>
              </div>
            </template>
          </template>
          <a-pagination style="margin-top: -30px" v-model="current" :total="$t('home.viewpoints.videos').length" :pageSize="6" size="small" />
        </div>
      </div>
      <div v-if="pc" style="font-size: 20px;color: #00023d;border-bottom: 1px #00023d solid;margin-bottom: 50px">{{$t('viewpoints.all')}}</div>
      <div v-if="pc" style="display: flex;flex-wrap: wrap;justify-content: space-between">
        <div v-for="(item, index) in data" :key="index" style="width: 20%;margin-bottom: 30px">
          <img :src="isEn?`acnImg/viewpoints/pdf/${item.eposition}.png`:`acnImg/viewpoints/pdf_c/${item.eposition}.png`"
               @click="pdf(item)"
               style="margin: 0 10% 20px;cursor: pointer" width="80%" />
          <div style="padding-left: 15%;color: #7f1f20;font-size: 16px;line-height: 18px">{{isEn?item.etitle:item.ctitle}}</div>
          <div style="padding-left: 15%;margin: 5px 0;line-height: 1">{{isEn?item.ename:item.cname}}</div>
          <span @click="pdf(item)" style="margin-left: 15%;border-bottom: 1px #a6a6a6 solid;color: #a6a6a6;cursor: pointer">{{isEn?'Download':'下载'}}</span>
        </div>
        <div v-for="i in (5 - data.length % 5)" :key="-i" style="width: 20%;margin-bottom: 30px"></div>
      </div>
      <div v-else style="display: flex;flex-wrap: wrap;justify-content: space-between">
        <div v-for="(item, index) in data" :key="index" style="width: 33%;margin-bottom: 30px">
          <img :src="isEn?`acnImg/viewpoints/pdf/${item.eposition}.png`:`acnImg/viewpoints/pdf_c/${item.eposition}.png`"
               @click="pdf(item)"
               style="margin: 0 10% 20px;cursor: pointer" width="80%" />
          <div style="padding-left: 15%;color: #7f1f20;font-size: 20px;line-height: 24px">{{isEn?item.etitle:item.ctitle}}</div>
          <div style="padding-left: 15%;margin: 5px 0;line-height: 1;font-size: 20px">{{isEn?item.ename:item.cname}}</div>
          <span @click="pdf(item)" style="margin-left: 15%;border-bottom: 1px #a6a6a6 solid;color: #a6a6a6;font-size: 18px">{{isEn?'Download':'下载'}}</span>
        </div>
        <div v-for="i in (4 - data.length % 4)" :key="-i" style="width: 25%;margin-bottom: 30px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'
export default {
  name: 'Viewpoints',
  data () {
    return {
      page: 1,
      data: [],
      m1: false,
      m2: false,
      m3: false,
      current: 1
    }
  },
  computed: {
    ...mapGetters(['isEn', 'pc'])
  },
  methods: {
    async query () {
      const t = await request.get('/points/list')
      this.data = t.filter(x => x.lang === 1)
    },
    pdf (item) {
      if (this.isEn) {
        window.open(`/pdf/viewpoints/${item.etitle2}.pdf`, '_blank')
      } else {
        window.open(`/pdf/viewpoints/${item.ctitle2}.pdf`, '_blank')
      }
    },
    pdf2 (name) {
      window.open(`/pdf/viewpoints/${name}.pdf`, '_blank')
    },
    more (i) {
      if (i === 1) {
        this.m1 = !this.m1
      } else if (i === 2) {
        this.m2 = !this.m2
      } else if (i === 3) {
        this.m3 = !this.m3
      }
    },
    change () {
      this.m1 = false
      this.m2 = false
      this.m3 = false
      window.scrollTo(0, 0)
    }
  },
  mounted () {
    this.query()
  }
}
</script>
